'use client';

import config from './global';

interface RequestParams {
  [key: string]: any;
}

const ShopApi = {
  categoryList: (params: RequestParams = {}) => {
    return config.axiosHandleShop().get(`${config.apiFolder}/category/list`, { params });
  },
  productList: (params: RequestParams = {}) => {
    return config.axiosHandleShop().get(`${config.apiFolder}/product/list`, { params });
  },
};

export default ShopApi;
